import React from "react";
import { useNavigate } from "react-router-dom";

const Page1Mobile = ({ sectionStyle }) => {
  const navigate = useNavigate();
  const cardStyle = {
    borderRadius: "16px",
    textAlign: "center",
    fontWeight: 400,
    fontSize: "16px",
    color: "#000",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "16px",
  };
  return (
    <div
      style={{ ...sectionStyle, gap: "36px" }}
      className="d-flex flex-column align-items-center justify-content-center"
    >
      <div
        className="d-flex flex-column text-center align-items-center"
        style={{ gap: "20px" }}
      >
        <div
          style={{
            fontSize: "27px",
            fontWeight: "600",
            color: "black",
            lineHeight: "120%",
          }}
        >
          <div>Plan Your Looks.</div>
          <div>Shop Together.</div>
          <div>Get Instant Feedback.</div>
        </div>
        <div
          style={{
            width: "180px",
            height: "42px",
            borderRadius: "100px",
            backgroundColor: "#0D8ED1",
            color: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "16px",
            fontWeight: "400",
            cursor: "pointer",
          }}
          onClick={() => navigate("/SignIn")}
        >
          Explore Lookflock
        </div>
      </div>
      <div className="d-flex justify-content-center">
        <div
          className="d-flex flex-column"
          style={{ width: "93vw", gap: "14px" }}
        >
          <div className="d-flex w-100" style={{ gap: "14px" }}>
            <div className="d-flex flex-column w-100" style={{ gap: "14px" }}>
              <div
                style={{
                  ...cardStyle,
                  height: "170px",
                  backgroundColor: "#DFF4FF",
                }}
              >
                <svg
                  style={{ width: "50px", height: "50px" }}
                  width="60"
                  height="61"
                  viewBox="0 0 60 61"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g opacity="0.96">
                    <rect
                      y="0.5"
                      width="60"
                      height="60"
                      rx="30"
                      fill="#2596D1"
                      fill-opacity="0.1"
                    />
                    <path
                      d="M37.1258 19.6824L25.7825 22.4032C24.1261 22.7965 22.4469 24.4028 22.0357 25.9872L19.1913 36.8376C18.3346 40.1157 20.4364 42.1372 23.8748 41.3176L35.2181 38.6078C36.8631 38.2144 38.5537 36.5972 38.965 35.0237L41.8093 24.1624C42.6661 20.8843 40.5528 18.8628 37.1258 19.6824Z"
                      fill="#2596D1"
                    />
                    <path
                      d="M30.5 34.5C32.433 34.5 34 32.933 34 31C34 29.067 32.433 27.5 30.5 27.5C28.567 27.5 27 29.067 27 31C27 32.933 28.567 34.5 30.5 34.5Z"
                      fill="white"
                    />
                  </g>
                </svg>
                Discover Trends
              </div>
              <div
                style={{
                  ...cardStyle,
                  height: "200px",
                  backgroundColor: "#F5FFEE",
                }}
              >
                <svg
                  style={{ width: "50px", height: "50px" }}
                  width="60"
                  height="61"
                  viewBox="0 0 60 61"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g opacity="0.96">
                    <rect
                      y="0.5"
                      width="60"
                      height="60"
                      rx="30"
                      fill="#76C33E"
                      fill-opacity="0.1"
                    />
                    <path
                      d="M35.5 20.9716C33.882 20.0357 32.0035 19.5 30 19.5C23.9249 19.5 19 24.4249 19 30.5C19 32.2597 19.4132 33.9228 20.1478 35.3977C20.343 35.7897 20.408 36.2377 20.2948 36.6607L19.6397 39.1094C19.3552 40.1723 20.3277 41.1447 21.3907 40.8604L23.8393 40.2052C24.2623 40.092 24.7103 40.157 25.1023 40.3521C26.5772 41.0868 28.2403 41.5 30 41.5C36.0751 41.5 41 36.5751 41 30.5C41 28.4965 40.4643 26.618 39.5284 25"
                      fill="#76C33E"
                    />
                    <path
                      d="M25 30.5H25.0112M29.9887 30.5H30M34.9887 30.5H35"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                </svg>
                Get Feedback
              </div>
            </div>
            <div className="d-flex flex-column w-100" style={{ gap: "14px" }}>
              <div
                style={{
                  ...cardStyle,
                  height: "200px",
                  backgroundColor: "#FFF2EA",
                }}
              >
                <svg
                  style={{ width: "50px", height: "50px" }}
                  width="60"
                  height="61"
                  viewBox="0 0 60 61"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g opacity="0.96">
                    <rect
                      y="0.5"
                      width="60"
                      height="60"
                      rx="30"
                      fill="#AD6B00"
                      fill-opacity="0.1"
                    />
                    <path
                      d="M28.9329 27.8337C31.8785 27.8337 34.2663 25.4458 34.2663 22.5003C34.2663 19.5548 31.8785 17.167 28.9329 17.167C25.9874 17.167 23.5996 19.5548 23.5996 22.5003C23.5996 25.4458 25.9874 27.8337 28.9329 27.8337Z"
                      fill="#AD6B00"
                    />
                    <path
                      d="M38.834 30.4995V28.3335H36.667C36.391 28.3335 36.1672 28.1095 36.167 27.8335C36.167 27.5574 36.3908 27.3335 36.667 27.3335H38.834V25.1665C38.834 24.8904 39.0578 24.6665 39.334 24.6665C39.61 24.6667 39.834 24.8905 39.834 25.1665V27.3335H42L42.1016 27.3433C42.3292 27.3901 42.5 27.592 42.5 27.8335C42.4998 28.0748 42.3291 28.276 42.1016 28.3228L42 28.3335H39.834V30.4995C39.834 30.7755 39.61 30.9993 39.334 30.9995C39.0578 30.9995 38.834 30.7757 38.834 30.4995Z"
                      fill="#AD6B00"
                    />
                    <path
                      d="M39.5966 38.4997C39.5999 38.2807 39.5999 38.0583 39.5999 37.833C39.5999 34.5193 34.8243 31.833 28.9333 31.833C23.0422 31.833 18.2666 34.5193 18.2666 37.833C18.2666 41.1467 18.2666 43.833 28.9333 43.833C31.9079 43.833 34.053 43.6241 35.5999 43.2509"
                      fill="#AD6B00"
                    />
                  </g>
                </svg>
                Invite Friends
              </div>
              <div
                style={{
                  ...cardStyle,
                  height: "170px",
                  backgroundColor: "#EAECFF",
                }}
              >
                <svg
                  style={{ width: "50px", height: "50px" }}
                  width="60"
                  height="61"
                  viewBox="0 0 60 61"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g opacity="0.96">
                    <rect
                      y="0.5"
                      width="60"
                      height="60"
                      rx="30"
                      fill="#2D38A8"
                      fill-opacity="0.1"
                    />
                    <path
                      d="M28.9258 19.3506C29.2661 18.5807 29.4364 18.1958 29.6733 18.0772C29.8792 17.9743 30.1209 17.9743 30.3267 18.0772C30.5637 18.1958 30.7339 18.5807 31.0743 19.3506L33.7852 25.4829C33.8859 25.7105 33.9362 25.8243 34.0141 25.9114C34.0829 25.9885 34.1672 26.0502 34.2611 26.0924C34.3674 26.1401 34.4903 26.1532 34.7361 26.1794L41.3582 26.8841C42.1896 26.9725 42.6052 27.0168 42.7903 27.2074C42.951 27.373 43.0256 27.6048 42.9921 27.834C42.9536 28.0979 42.6431 28.38 42.0221 28.9443L37.0755 33.439C36.892 33.6057 36.8001 33.6892 36.742 33.7907C36.6906 33.8807 36.6584 33.9805 36.6476 34.0836C36.6354 34.2003 36.661 34.3221 36.7123 34.566L38.094 41.1337C38.2675 41.9583 38.3542 42.3705 38.2316 42.6068C38.125 42.8123 37.9295 42.9555 37.7029 42.9942C37.4421 43.0386 37.08 42.8281 36.3558 42.407L30.5876 39.0525C30.3736 38.928 30.2666 38.8659 30.1528 38.8414C30.0521 38.8199 29.948 38.8199 29.8473 38.8414C29.7335 38.8659 29.6264 38.928 29.4124 39.0525L23.6442 42.407C22.9201 42.8281 22.558 43.0386 22.2972 42.9942C22.0706 42.9555 21.875 42.8123 21.7685 42.6068C21.6459 42.3705 21.7326 41.9583 21.9061 41.1337L23.2877 34.566C23.339 34.3221 23.3646 34.2003 23.3524 34.0836C23.3417 33.9805 23.3095 33.8807 23.2581 33.7907C23.1999 33.6892 23.1081 33.6057 22.9245 33.439L17.978 28.9443C17.357 28.38 17.0465 28.0979 17.0079 27.834C16.9744 27.6048 17.0491 27.373 17.2098 27.2074C17.3949 27.0168 17.8105 26.9725 18.6419 26.8841L25.264 26.1794C25.5097 26.1532 25.6326 26.1401 25.7389 26.0924C25.8329 26.0502 25.9171 25.9885 25.986 25.9114C26.0638 25.8243 26.1141 25.7105 26.2148 25.4829L28.9258 19.3506Z"
                      fill="#2D38A8"
                    />
                  </g>
                </svg>
                Add to Favourites
              </div>
            </div>
          </div>
          <div
            style={{
              ...cardStyle,
              flexDirection: "row",
              width: "100%",
              height: "100px",
              backgroundColor: "#FFEEF4",
            }}
          >
            <svg
              style={{ width: "50px", height: "50px" }}
              width="61"
              height="60"
              viewBox="0 0 61 60"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.5"
                width="60"
                height="60"
                rx="30"
                fill="#E4487F"
                fill-opacity="0.1"
              />
              <path
                d="M42.13 22.0271V40.3898C42.13 42.7336 40.4489 43.7196 38.396 42.5881L32.0435 39.0481C31.3646 38.6763 30.2654 38.6763 29.5865 39.0481L23.2339 42.5881C21.1811 43.7196 19.5 42.7336 19.5 40.3898V22.0271C19.5 19.263 21.763 17 24.5271 17H37.1029C39.867 17 42.13 19.263 42.13 22.0271Z"
                fill="#E4487F"
              />
            </svg>
            Create Shopping List
          </div>
        </div>
      </div>
    </div>
  );
};

export default Page1Mobile;
